<template>
  <v-app>
    <AppHeader :logoPath="logoPath" />
    <v-main class="main-background">
      <v-container fluid>
        <div class="content-area">
          <div class="tabbed-area-container">
            <v-row class="tabu-row" :class="{ 'flex-column': isNarrowScreen }">
              <v-col cols="auto"> </v-col>
              <v-col cols="auto" class="datepicker-column">
                <DatePickerDialog @update-date="handleDateChange" />
              </v-col>
              <v-col cols="auto" class="col-3">
                <v-tabs v-model="activeTab" @update:modelValue="handleTabChange">
                  <v-tab
                    v-for="(tab, index) in tabs"
                    :key="tab"
                    :style="
                      index !== tabs.length - 1
                        ? 'border-right: 1px solid #ccc;'
                        : ''
                    "
                    :class="{ 'active-tab': activeTab === index }"
                    >{{ tab }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-col cols="auto" class="col-4">
                <multiselect
                  v-model="selectedRegion"
                  :options="availableOptions"
                  placeholder=""
                  :searchable="true"
                  :preserve-search="true"
                  @select="handleSelect"
                  class="custom-multiselect-width"
                  :show-labels="false"
                >
                  <template v-slot:noResult>
                    <span>{{ "結果無し" }}</span>
                  </template>
                </multiselect>
              </v-col>
              <v-col style="min-width: 400px;">
                <div class="search">
                  <input type="text" v-model="searchKeyword" value="" class="custom-input-search input__tags"
                    placeholder="検索キーワードをご入力ください" autocomplete="off" role="textbox" aria-autocomplete="list" />
                  <v-btn color="primary" @click="handleSearch(searchKeyword)"
                    >検索
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <br />
            <div v-if="dialogMessage" class="error-message">
                {{ dialogMessage }}
            </div>
            <v-list class="scrollable-list">
                <template v-if="filteredNewsData.length > 0">
                  <v-list-item
                    v-for="item in paginatedNewsData"
                    :key="item.article_id"
                    class="list-item"
                    style="border-bottom: 1px solid #ccc; margin-bottom: 10px"
                  >
                    <v-row align="start">
                      <v-col :cols="2">
                        <span
                          class="responsive-font"
                          style="font-size: 15px; color: gray"
                        >
                          <template v-if="isMoreNarrowScreen">
                            {{ item.publish_date.split("-")[0] }}/<br />{{
                              item.publish_date.split("-")[1]
                            }}/{{ item.publish_date.split("-")[2] }}
                          </template>
                          <template v-else>
                            {{ item.publish_date }}
                          </template>
                        </span>
                      </v-col>
                      <v-col :cols="isNarrowScreen ? 1.3 : 1">
                        <span 
                          v-if="item.regions.length === 0" 
                          class="responsive-font region-tag" 
                          style="font-size: 15px; display: block;"
                        >
                          全国
                        </span>
                        <span 
                          v-else
                          v-for="(region, index) in item.regions" 
                          :key="index" 
                          class="responsive-font region-tag" 
                          style="font-size: 15px; display: block;"
                        >
                          {{ region }}{{ index < item.regions.length - 1 ? ',' : '' }}
                        </span>
                      </v-col>
                      <v-col :cols="isNarrowScreen ? 1.3 : 1">
                        <span
                          v-if="item.industries.length === 0" 
                          class="responsive-font industry-tag"
                          style="font-size: 15px; display: block;"
                          >
                          (業界カテゴリなし)
                        </span>
                        <span
                          v-else
                          v-for="(industry, index) in item.industries"
                          :key="index"
                          class="responsive-font industry-tag"
                          :style="{
                            fontSize: '15px',
                            color: getTagColor(industry),
                            marginRight: index < item.industries.length - 1 ? '5px' : '0',
                            display: 'block'
                          }"
                        >
                          {{ industry }}{{ index < item.industries.length - 1 ? ',' : '' }}
                        </span>
                      </v-col>
                      <v-col
                        :style="
                          isNarrowScreen
                            ? { flex: '0 0 58.33%', maxWidth: '58.33%' }
                            : { flex: '0 0 66.66%', maxWidth: '66.66%' }
                        "
                      >
                        <div class="d-flex align-center">
                          <router-link
                            :to="{ name: 'NewsDetail', params: { article_id: item.article_id } }"
                            class="truncate-title"
                            target="_blank"
                          >
                            <span>{{ item.title || '(タイトルなし)' }}</span>
                          </router-link>
                        </div>
                        <div class="d-flex align-center" style="margin-bottom: 10px;">
                          <v-btn
                            @click="createSalesTalk(item.article_id)"
                            style="
                              background-color: lightblue;
                              border-radius: 15px;
                              padding: 4px 8px;
                              font-size: 12px;
                              height: 24px;
                            "
                          >
                            営業トーク例作成
                          </v-btn>
                          <div style="width: 2em"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
                <template v-else>
                  <v-list-item class="list-item">
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <span style="color: gray;">{{ newsListMessage }}</span>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
              </v-list>
            <v-pagination
              v-model="currentPage"
              :length="Math.ceil(filteredNewsData.length / itemsPerPage)"
            ></v-pagination>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
import DatePickerDialog from "../components/common/DatePickerDialog.vue";
import { useRouter } from "vue-router";
import { parse, startOfDay } from "date-fns";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { fetchNews, keywordSearchNews } from "@/api";
import { errorMessages } from "@/constants/errorMessages.js"
import { ref, onMounted } from "vue";
import { inject } from 'vue';

let gtm = null;

export default {
  components: {
    AppHeader,
    DatePickerDialog,
    Multiselect,
  },
  setup() {
    const apiNewsData = ref([]);
    const router = useRouter();
    const dialogMessage = ref('');
    const isMiddleScreen = ref(window.innerWidth < 1200);
    const isNarrowScreen = ref(window.innerWidth < 720);
    const isMoreNarrowScreen = ref(window.innerWidth < 600);
    const selectedDate = ref(null);
    const newsListMessage = ref('');
    const searchKeyword = ref('');

    window.addEventListener("resize", () => {
      isMiddleScreen.value = window.innerWidth < 1200;
      isNarrowScreen.value = window.innerWidth < 720;
      isMoreNarrowScreen.value = window.innerWidth < 600;
    });

    const createSalesTalk = (newsId) => {
      gtm?.sendAiTalkButtonEvent()
      window.open(router.resolve({ name: "UsageAgreement", params: { article_id: newsId } }).href, '_blank');
    };

    // コンポーネントがマウントされたときにデータを取得
    onMounted(async () => {
      gtm = inject('$gtm');
      try {
        newsListMessage.value = "ニュースデータ読み込み中。";
        const response = await fetchNews();
        if (response.status === 200) {
          newsListMessage.value = "ニュースデータがありません。";
          if (response.data.errno !== undefined) {
            dialogMessage.value = errorMessages.e01201(response.data.errno, response.status);
          }
          else {
            const data = response.data;
            // エラーデータを除外
            const validData = data.filter(item => item.article_id);
            applyDefaultFilters();

            // 14日以上前のニュースが存在する場合
            if (validData.some(item => new Date(item.publish_date) < new Date(Date.now() - 14 * 24 * 60 * 60 * 1000))) {
                dialogMessage.value = errorMessages.e01202;
            }
            else {
              // 正常なデータ
              apiNewsData.value = validData;
            }
          }
        } else {
          dialogMessage.value = errorMessages.e01201(response.data.errno, response.status);
        }
      } catch (error) {
        if (error.response) {
          dialogMessage.value = errorMessages.e01201(error.response.data.errno, error.response.status);
        }
      }
    });

    // デフォルトの絞り込みを適用する関数
    const applyDefaultFilters = () => {
      const today = new Date();
      selectedDate.value = today.toISOString().split('T')[0];
    };

    const handleSearch = async () => {
      try {
        gtm?.sendSearchWords(searchKeyword.value);
        dialogMessage.value = "";  // エラーメッセージを初期化
        newsListMessage.value = "ニュースデータ読み込み中。";
        apiNewsData.value = [];  // 検索前にデータを初期化
        const response = await keywordSearchNews(searchKeyword.value);
        if (response.status === 200) {
          newsListMessage.value = "ニュースデータがありません。";
          // APIからはstatusが200でもerrnoが返ってくるケースは無いので、分岐処理は用意しない
          const data = response.data;
          // エラーデータを除外
          const validData = data.filter(item => item.article_id);
          applyDefaultFilters();
          apiNewsData.value = validData;
        } else {
          dialogMessage.value = errorMessages.e01203(response.data.errno, response.status);
        }
      } catch (error) {
        if (error.response) {
          dialogMessage.value = errorMessages.e01203(error.response.data.errno, error.response.status);
        }
      }
    };

    return {
      createSalesTalk,
      handleSearch,
      isMiddleScreen,
      isNarrowScreen,
      isMoreNarrowScreen,
      dialogMessage,
      apiNewsData,
      selectedDate,
      newsListMessage,
      searchKeyword,
    };
  },
  data() {
    return {
      activeTab: 0,
      tabs: ["全て", "小売・飲食", "建設・不動産", "食品", "金融", "運輸", "公的機関・大学"],
      regions: [
        "全国",
        "北海道",
        "東北地方",
        "北陸地方",
        "北関東地方",
        "首都圏",
        "中部地方",
        "東海地方",
        "近畿地方",
        "中国地方",
        "四国地方",
        "九州地方・沖縄"
      ],
      selectedRegion: "全国",
      filteredOptions: [],
      menu: false,
      currentPage: 1,
      itemsPerPage: 20,
      linkCopyButtonPath: require("@/assets/link_copy_icon.png"),
      logoPath: require("@/assets/page_title.png"),
    };
  },
  methods: {
    applyDefaultFilters() {
      const today = new Date();
      this.selectedDate = today.toISOString().split('T')[0];
    },

    saveDate(date) {
      this.selectedDate = date;
      this.menu = false;
    },

    handleDateChange(dates) {
      this.selectedDate = dates;
      this.currentPage = 1;
    },

    handleSelect(selected) {
      this.selectedRegion = selected;
      this.currentPage = 1;
    },

    handleTabChange(tabIndex) {
      this.activeTab = tabIndex;
      this.currentPage = 1;
    },

    customFilter(item, queryText, itemText) {
      const hasValue = (val) => (val != null ? val : "");
      const text = hasValue(itemText);
      const query = hasValue(queryText);
      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },

    getTagColor(tag) {
      switch (tag) {
        case "小売・飲食":
          return "deepskyblue";
        case "建設・不動産":
          return "brown";
        case "食品":
          return "green";
        case "金融":
          return "gold"
        case "運輸":
          return "orange";
        case "公的機関・大学":
          return "red";
        default:
          return "black";
      }
    },
  },
  computed: {
    availableOptions() {
      // 選択されている項目をリストから除外
      return this.regions.filter((option) => option !== this.selectedRegion);
    },

    filteredNewsData() {
      // apiNewsDataを使用するように変更
      let filteredData = this.apiNewsData;
      // タブによる絞り込み
      if (this.activeTab !== 0) {
        const category = this.tabs[this.activeTab];
        filteredData = filteredData.filter(item => item.industries.includes(category));
      }

      // 地域による絞り込み
      if (this.selectedRegion !== "全国") {
        filteredData = filteredData.filter(item => item.regions.includes(this.selectedRegion));
      }

      // 日付範囲での絞り込み
      if (this.selectedDate && this.selectedDate.length === 2) {
        const [start, end] = this.selectedDate.map((date) =>
          startOfDay(new Date(date))
        );

        filteredData = filteredData.filter((item) => {
          const itemDate = startOfDay(
            parse(item.publish_date, "yyyy-MM-dd", new Date())
          );
          return itemDate >= start && itemDate <= end;
        });
      }

      return filteredData;
    },

    paginatedNewsData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredNewsData.slice(start, end);
    },
  },
};

</script>

<style scoped>
html {
  font-family: "Hiragino Sans", sans-serif;
}
body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #f0f0f0;
  min-width: 1300px; /* 最低横幅を1300pxに設定 */
  overflow-x: auto;
}

/* ヘッダー部分の色と下部とのマージン */
header {
  background-color: #ffffff;
  margin-bottom: 5px;
  width: 100vw;
  margin-left: -14%;
  position: relative;
}

/* ヘッダロゴ画像 */
.logo img {
  width: 277px;
  height: 50px;
  padding: 5px;
}

/* ヘッダロゴ */
.logo {
  margin-left: 16%;
}

.main-background {
  background-color: #f0f0f0;
  width: 100%;
}

.main-container {
  background-color: #f0f0f0;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.content-area {
  flex: 1;
  background-color: #f0f0f0;
  width: 100%;
}

.tabbed-area-container {
  background-color: #f5f5f5;
  padding: 10px;
  border: 1px solid #ccc;
  margin: 10px auto;
  width: 100%;
}

.custom-multiselect-width {
  width: 10em;
}

.custom-input-search {
  width: 25em;
  font-size: 1em;
  box-sizing: border-box;
}

.input__tags {
  min-height: 40px;
  display: block;
  padding: 8px 8px 8px 8px;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  background: #fff;
  font-size: 14px;
}

.search {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ニュース一覧の各項目の幅を調整 */
.v-list-item .v-row .v-col:first-child {
  flex-basis: 15% !important;
  max-width: 30% !important;
}

/* 2列目と3列目の幅を広げる */
.v-list-item .v-row .v-col:nth-child(2) {
  flex-basis: 15% !important;
  max-width: 15% !important;
}

.v-list-item .v-row .v-col:nth-child(3) {
  flex-basis: 20% !important;
  max-width: 30% !important;
}

.v-list-item .v-row .v-col:last-child {
  flex-basis: 50% !important;
  max-width: 50% !important;
}

::v-deep .multiselect__option,
::v-deep .multiselect__single,
::v-deep .multiselect__placeholder {
  font-size: 1em;
}

.scrollable-list {
  overflow-y: hidden;
  width: 100%;
  margin: 0;
}

.truncate-title {
  display: block;
  width: 100%;
  white-space: normal;
  overflow: hidden;
  word-break: break-all;
}

.datepicker-column,
.tabs-column {
  padding-left: 0;
  padding-right: 0;
}

.datepicker-column {
  margin-right: 10px;
}

.tabs-column {
  margin-left: 10px;
}

.error-message {
  color: red;
  text-align: center;
  margin: 10px 0;
  padding: 10px;
  font-weight: bold;
}

</style>


